export default function formatForcableAmount(amount) {
    var _a, _b;
    return (_b = (_a = amount === null || amount === void 0 ? void 0 : amount.forcedValue) !== null && _a !== void 0 ? _a : amount === null || amount === void 0 ? void 0 : amount.baseValue) !== null && _b !== void 0 ? _b : null;
}
